import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { updateSelectedItems } from '../../../redux/actions/products';
import { thresholdsByItem } from '../../../redux/actions/thresholds';

import LoadingSpinner from '../../partials/LoadingSpinner';
import { Text, Button, Checkbox, H4, Input, Badge } from '@bigcommerce/big-design';
import { DeleteIcon, EditIcon } from '@bigcommerce/big-design-icons';

import UpdateThresholdModal from './UpdateThresholdModal';
import DeleteThresholdModal from './DeleteThresholdModal';

const ThresholdLine = ({ 
  payload,
  hasVariants,
  activeAddressId,
  productId,
  itemId,
  imageUrl,
  fullImageUrl,
  inventoryTracking,
  options,
  name,
  quantity,
  price,
  binPickingNumber,
  selectedProductList,
  setSelectedProductList,
  products,
  type,
  rowId,
  targetInventory,
  setTargetInventory,
  lowInventory,
  setLowInventory,
  setCriticalInventory,
  criticalInventory,
  thresholds,
  itemThresholds,
  getThresholds,
  bigcommerceSettings,
  submitted
}) => {
  const [activeThreshold, setActiveThreshold] = useState(null);
  const [showUpdateThresholdModal, setShowUpdateThresholdModal] = useState(false);
  const [showDeleteThresholdModal, setShowDeleteThresholdModal] = useState(false);

  const [lineThreshold, setLineThreshold] = useState(false);

  let section = !!options ? selectedProductList.variants : selectedProductList.products;
  let inList = Object.keys(section).indexOf(String(itemId)) > -1;

  useEffect(() => {
    if(type === 'variant') {
      getThresholds(payload, activeAddressId, productId, itemId);
    } else {
      getThresholds(payload, activeAddressId, productId, null);
    }
  }, []);

  useEffect(() => {
    setLineThreshold(false);

    if((type === 'variant') && itemThresholds[`${productId}/${itemId}`]) {
      setLineThreshold(itemThresholds[`${productId}/${itemId}`]);
    }

    if((type === 'product') && itemThresholds[`${productId}/null`]) {
      setLineThreshold(itemThresholds[`${productId}/null`]);
    }

  }, [thresholds]);

  const showEditModal = () => {
    let threshold = lineThreshold;
    threshold.product_id = productId;
    if(type === 'variant') { threshold.variant_id = itemId; }
    setActiveThreshold(threshold);
    setShowUpdateThresholdModal(true);
  }

  const showDeleteModal = () => {
    let threshold = lineThreshold;
    threshold.product_id = productId;
    if(type === 'variant') { threshold.variant_id = itemId; }    
    setActiveThreshold(threshold);
    setShowDeleteThresholdModal(true);
  }

  const switchSelection = () => {
    if (inList) {
      delete section[itemId];
    } else {
      section[itemId] = {
        productId: productId,
        imageUrl: imageUrl,
        fullImageUrl: fullImageUrl,
        options: options,
        name: name,
        quantity: quantity,
        price: price,
        binPickingNumber: binPickingNumber
      };
    }

    setSelectedProductList({ ...selectedProductList });
  };

  const setThresholdValue = (itemId, type, e, setter) => {
    section[itemId] = {
      productId: productId,
      imageUrl: imageUrl,
      fullImageUrl: fullImageUrl,
      options: options,
      name: name,
      quantity: quantity,
      price: price,
      binPickingNumber: binPickingNumber
    };

    setSelectedProductList({ ...selectedProductList });
    setter(itemId, type, e);
  }

  return(
    <>
      <div className="has-hover sku-line flex-container">
        <div className={`flex-1 ${type === 'variant' && 'left-15'}`}>
          <div className="flex-container">
            { !lineThreshold && !thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) && ((inventoryTracking === 'product' && type === 'product') || (inventoryTracking === 'none' && !hasVariants) || (type === 'variant')) &&
              <Checkbox
                id={itemId}
                checked={inList}
                onChange={() => switchSelection()}
              />
            }
            { thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) &&
              <LoadingSpinner
                size="xxSmall"
                statusText=" "
              />
            }
            <div className="left-15">
              { imageUrl && <img src={imageUrl} /> }
              { !imageUrl && <Text>No image</Text>}
            </div>
          </div>
        </div>
        <div className={lineThreshold ? "flex-1" : "flex-3"}>
          <div className="flex-container">
            <H4>{name}</H4>
          </div>
          <ul>
            { options && options.map(option =>
                <li>
                  <strong>{ option.option_display_name }</strong>: { option.label }
                </li>
              )
            }
            { !options &&
              <Text color="warning40">
                Base Product
              </Text>
            }
            { (inventoryTracking === 'none') &&
              <Text color="danger40">Inventory not tracked</Text>
            }
          </ul>

        </div>

        { !lineThreshold && !thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) && ((inventoryTracking === 'product' && type === 'product') || (inventoryTracking === 'none' && !hasVariants) || (type === 'variant')) &&
          <div className="flex-3">
            <div className="flex-container flex-end">
              <Text as='span'>Target Inventory &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setThresholdValue(itemId, type, e, setTargetInventory)}
                placeholder="Target Inventory"
                value={targetInventory}
                type="number"
                min="0"
                disabled={submitted}
              />
            </div>

            <div className="flex-container flex-end">
              <Text as='span'>Low Inventory &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setThresholdValue(itemId, type, e, setLowInventory)}
                placeholder="Low Inventory"
                value={lowInventory}
                type="number"
                min="0"
                disabled={submitted}
              />
            </div>

            <div className="flex-container flex-end">
              <Text as='span'>Critical Inventory &nbsp;&nbsp;</Text>
              <Input
                required
                onChange={(e) => setThresholdValue(itemId, type, e, setCriticalInventory)}
                placeholder="Critical Inventory"
                value={criticalInventory}
                type="number"
                min="0"
                disabled={submitted}
              />
            </div>
          </div>
        }

        { thresholds.itemSearchingThresholds.find(item => item === `${productId}/${itemId}`) &&
          <LoadingSpinner
            size="xxSmall"
            statusText="Loading thresholds"
          />
        }

        { lineThreshold &&
          <>
            <div className="flex-1">
              <div className="left-15">
                <H4>Threshold Details</H4>
                <ul>
                  <li>Target Inventory: <Badge label={lineThreshold.target_inventory || "Not set"} variant={lineThreshold.target_inventory ? "success" : "warning"} /></li>
                  <li>Low Inventory: <Badge label={lineThreshold.low_inventory || "Not set"} variant={lineThreshold.low_inventory ? "success" : "warning"} /></li>
                  <li>Critical Inventory: <Badge label={lineThreshold.critical_inventory || "Not set"} variant={lineThreshold.critical_inventory ? "success" : "warning"} /></li>
                </ul>
              </div>
            </div>
            <div className="flex-1">
              <Button
                onClick={() => showEditModal()}
                variant="secondary"
                disabled={submitted || thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                iconLeft={<EditIcon />}
              >
                Edit Thresholds
              </Button>
              <br/>
              <br/>
              <Button
                onClick={() => showDeleteModal()}
                variant="secondary"
                actionType="destructive"
                disabled={submitted || thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${productId}/${itemId}`)}
                iconLeft={<DeleteIcon />}
              >
                Remove Thresholds
              </Button>
            </div>
          </>
        }
      </div>

      <UpdateThresholdModal
        payload={payload}
        locationId={activeAddressId}
        showUpdateThresholdModal={showUpdateThresholdModal}
        setShowUpdateThresholdModal={setShowUpdateThresholdModal}
        threshold={activeThreshold}
        thresholdName={name}
      />

      <DeleteThresholdModal
        payload={payload}
        locationId={activeAddressId}
        showDeleteThresholdModal={showDeleteThresholdModal}
        setShowDeleteThresholdModal={setShowDeleteThresholdModal}
        threshold={activeThreshold}
        thresholdName={name}
      />
    </>
  )
}

const mapStateToProps = state => ({
  selectedProductList: state.products.selectedProductList,
  products: state.products,
  thresholds: state.thresholds,
  itemThresholds: state.thresholds.itemThresholds,
  bigcommerceSettings: state.stores.settings,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),
  getThresholds: (payload, locationId, productId, variantId) => dispatch(thresholdsByItem(payload, locationId, productId, variantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdLine);
